module.exports = __webpack_public_path__ + "static/lulini-61d84e34cf615bbed3ccb520879e9734.png";